import { useEffect, useState } from "react";
import type { Driver } from "@eagledispatch/shared";
import { apiFetch } from "../../lib/api";
import Button from "../../components/Button";
import Card from "../../components/Card";
import type { DispatcherRoute } from "./DispatchHome";

export default function DriverList({
  onNavigate,
}: {
  onNavigate: (route: DispatcherRoute) => void;
}) {
  const [drivers, setDrivers] = useState<Driver[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    setError(null);
    apiFetch<Driver[]>("/api/v1/drivers?available=true")
      .then(setDrivers)
      .catch((e) => setError(e instanceof Error ? e.message : String(e)))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <main className="surface">
      <header className="surface-header">
        <Button variant="ghost" onClick={() => onNavigate({ name: "home" })}>
          ← Back
        </Button>
        <h1>Available Drivers</h1>
      </header>

      {loading ? (
        <p className="muted">Loading…</p>
      ) : error ? (
        <Card>
          <p className="err">Failed to load drivers.</p>
          <p className="muted">{error}</p>
          <Button onClick={load}>Retry</Button>
        </Card>
      ) : drivers && drivers.length === 0 ? (
        <Card>
          <p className="muted">No drivers available right now.</p>
        </Card>
      ) : (
        <ul className="driver-list">
          {drivers?.map((d) => (
            <li key={d.id} className="driver-row">
              <span className="driver-name">{d.name}</span>
              <span className="driver-phone">{d.phone ?? "—"}</span>
              <span className="tag tag--available">Available</span>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
